import styled from "@emotion/styled";

import {
  space,
  color,
  layout,
  typography,
  variant,
  position,
  flexbox,
} from "styled-system";
import { white, lightBlue } from "./colors";

const variants = {
  white: {
    transition: "all .5s ease",
    color: white,
    borderColor: white,
    "&:hover": {
      backgroundColor: white,
      color: lightBlue,
    },
  },
  unstyled: {
    textTransform: "none",
    padding: 0,
    border: "none",
  },
};

const Button = styled.button`
  background: none;
  box-shadow: none;
  border: none;
  font: inherit;
  cursor: pointer;
  display: inline-flex;
  align-items: center;

  text-transform: uppercase;
  color: ${lightBlue};
  padding: 0 72px;
  height: 47px;
  border: 2px solid ${lightBlue};

  ${variant({ variants })}
  ${typography}
  ${space}
  ${color}
  ${layout}
  ${position}
  ${flexbox}
`;

export default Button;
